import { atom } from 'recoil'

const BilletInfoStore = atom<{ billetInfo: { billetBarCode: string; billetUrl: string } }>({
  key: 'BilletInfoStore',
  default: null
})

export default BilletInfoStore
